<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <v-icon>mdi-account-multiple</v-icon
                    >{{ $t("FullAccessUsers") }}
                  </td>
                  <td>{{ fullUsers }}</td>
                </tr>
                <tr>
                  <td>
                    <v-icon>mdi-account-multiple</v-icon
                    >{{ $t("ReadonlyUsers") }}
                  </td>
                  <td>{{ readonlyUsers }}</td>
                </tr>
                <tr>
                  <td>
                    <v-icon>mdi-account-multiple</v-icon
                    >{{ $t("ConcurrentUsers") }}
                  </td>
                  <td>{{ concurrentUsers }}</td>
                </tr>
                <tr>
                  <td>
                    <v-icon>mdi-account-star</v-icon
                    >{{ $t("AutorecognitionUsers") }}
                  </td>
                  <td>{{ autorecognitionUsers }}</td>
                </tr>
                <tr>
                  <td>
                    <v-icon>mdi-cellphone-lock</v-icon
                    >{{ $t("TwoFactorAuthenticationUsers") }}
                  </td>
                  <td>{{ twoFactorAuthenticationUsers }}</td>
                </tr>
                <tr>
                  <td>
                    <v-icon>mdi-cellphone-android</v-icon
                    >{{ $t("RegisteredDevices") }}
                  </td>
                  <td>{{ registeredDevices }}</td>
                </tr>
                <tr>
                  <td><v-icon>mdi-text-box</v-icon>{{ $t("LicenceState") }}</td>
                  <td>{{ licenceState }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-fab-transition>
                <v-btn
                  color="blue-grey"
                  dark
                  absolute
                  top
                  right
                  fab
                  @click="updateLicence"
                  :loading="loading"
                  v-on="on"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-fab-transition>
            </template>
            <span>{{ $t("Refresh") }}</span>
          </v-tooltip>
        </v-card-text>
      </v-card>
    </v-row>
    <LicenceModal :ref="modalKey" @on-item-saved="onItemSaved" />
  </v-container>
</template>

<script>
import LicenceService from '@/services/LicenceService';
import Licence from '@/ecm/models/Licence';
import LicenceModal from '@/components/admin/LicenceModal.vue';

export default {
    components: {
        LicenceModal,
    },
    created() {
        LicenceService.getCurrent()
            .then((data) => {
                this.currentLicence = new Licence(data);
            })
            .catch(() => {
                this.currentLicence = new Licence();
            });
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        fullUsers() {
            if (this.currentLicence.fullUsers == '') {
                return '';
            }
            return Number.parseInt(this.currentLicence.fullUsers) >= 0
                ? this.currentLicence.fullUsers
                : this.$t('Unlimited');
        },
        concurrentUsers() {
            if (this.currentLicence.concurrentUsers == '') {
                return '';
            }
            return Number.parseInt(this.currentLicence.concurrentUsers) >= 0
                ? this.currentLicence.concurrentUsers
                : this.$t('Unlimited');
        },
        autorecognitionUsers() {
            if (this.currentLicence.autorecognitionUsers == '') {
                return '';
            }
            return Number.parseInt(this.currentLicence.autorecognitionUsers) >= 0
                ? this.currentLicence.autorecognitionUsers
                : this.$t('Unlimited');
        },
        readonlyUsers() {
            if (this.currentLicence.readonlyUsers == '') {
                return '';
            }
            return Number.parseInt(this.currentLicence.readonlyUsers) >= 0
                ? this.currentLicence.readonlyUsers
                : this.$t('Unlimited');
        },
        twoFactorAuthenticationUsers() {
            if (this.currentLicence.twoFactorAuthenticationUsers == '') {
                return '';
            }
            return Number.parseInt(
                this.currentLicence.twoFactorAuthenticationUsers
            ) >= 0
                ? this.currentLicence.twoFactorAuthenticationUsers
                : this.$t('Unlimited');
        },
        registeredDevices() {
            if (this.currentLicence.registeredDevices == '') {
                return '';
            }
            return Number.parseInt(this.currentLicence.registeredDevices) >= 0
                ? this.currentLicence.registeredDevices
                : this.$t('Unlimited');
        },
        licenceState() {
            switch (this.currentLicence.licenceState) {
            case 'Active':
                return this.$t('Active');
            case 'Trial':
                return this.$t('Trial');
            case 'Rejected':
                return this.$t('LicenceRejectedException');
            case 'ConnectionError':
                return this.$t('LicenceServerConnectionErrorException');
            case 'FullUsersLimitExceeded':
                return this.$t('FullUsersLicenceLimitException');
            case 'ReadonlyUsersLimitExceeded':
                return this.$t('ReadonlyUsersLicenceLimitException');
            case 'ConcurrentUsersLimitExceeded':
                return this.$t('ConcurrentUsersLicenceLimitException');
            case 'TwoFactorAuthenticationUsersLimitExceeded':
                return this.$t('TwoFactorAuthenticationUsersLicenceLimitException');
            case 'RegisteredDevicesLimitExceeded':
                return this.$t('RegisteredDevicesLicenceLimitException');
            case 'AutorecognitionUsersExceeded':
                return this.$t('AutorecognitionUsersLicenceLimitException');
            default:
                return this.$t('LicenceKeyNotFoundOrInvalidException');
            }
        },
        licenceEmpty() {
            return this.currentLicence.licenceState == '';
        },
    },
    data() {
        return {
            loading: false,
            modalKey: 'modalLicence',
            currentLicence: new Licence(),
        };
    },
    methods: {
        updateLicence() {
            if (this.licenceEmpty) {
                this.modalInstance.new();
            } else {
                this.loading = true;
                LicenceService.request({ Organization: '', Integrator: '' }).then(
                    (data) => {
                        LicenceService.getCurrent().then((data) => {
                            this.currentLicence = new Licence(data);
                            this.loading = false;
                        });
                    }
                );
            }
        },
        onItemSaved() {
            LicenceService.getCurrent().then((data) => {
                this.currentLicence = new Licence(data);
            });
        },
    },
};
</script>
